
import Decimal from 'decimal.js';

export const math = {
	add() {
		return comp('add', arguments);
	},
	subtract() {
		return comp('subtract', arguments);
	},
	multiply() {
		return comp('multiply', arguments);
	},
	divide() {
		return comp('divide', arguments);
	},
};

function comp(_func, args) {
	if (args.length === 0) return 0;
	
	let result = new Decimal(args[0] || 0);
	for (let i = 1; i < args.length; i++) {
		const num = new Decimal(args[i] || 0);
		switch (_func) {
			case 'add':
				result = result.add(num);
				break;
			case 'subtract':
				result = result.sub(num);
				break;
			case 'multiply':
				result = result.mul(num);
				break;
			case 'divide':
				result = result.div(num);
				break;
		}
	}
	// 防止超过6位使用科学计数法，转换为数字
	return result.toNumber();
}
